import instance from './instance';

export const createPIAccount = data => instance.post(`/account_management/pi_account`, data);

export const piUserExists = ({ email, piCompanyGuid }) =>
  instance.get(`/account_management/user_exists_in_same_org`, {
    params: { email: email, pi_company_guid: piCompanyGuid },
  });
